module.exports = __webpack_public_path__ + "play_store_download.5caf731.png";